import * as React from 'react'
import './Definition.css'

// import * as _ from 'lodash'
// import classNames from 'classnames'
// import { ObjectInspector } from 'react-inspector'

import MyCodeMirror, { Mark } from './MyCodeMirror'
import Token from './Token'

import { inputLabelsForCodeCall } from '../model/inputLabelsForCodeCall'
import { NetworkUser } from 'golgi'
import { Cursor } from '../lib/Cursor';
import * as Model from '../types/document'
import { Stack } from 'src/types/stack';


class CallCodeEditor extends React.Component<{
  callC: Cursor<Model.CodeCall>,
  graphC: Cursor<Model.Graph>,
  blockC: Cursor<Model.Block>,
  stack: Stack,
  desiredWidth?: number,
  maxFontSize?: number,
  minFontSize?: number
}> {
  render() {
    return <NetworkUser debugName="CallCodeEditor" props={this.props} state={this.state} render={() => {
      const {callC, graphC, blockC, stack, desiredWidth, maxFontSize, minFontSize} = this.props
      const call = callC.get()

      // Prepare marks
      let marks: Array<React.ReactNode> = []
      // console.log("preparing marks for", callC.get().code)
      const inputLabels = inputLabelsForCodeCall(callC, blockC)
      // console.log("inputLabels", inputLabels)
      call.inputs.forEach((input, i) => {
        const key = input.inside
        const labelInfo = inputLabels[i]

        let tokenLabel
        let tokenClass = ""

        if (labelInfo.type === 'named') {
          tokenLabel = labelInfo.name
          tokenClass = "font-node"
        } else {
          tokenLabel = call.inputs.length > 1 ? "in" + labelInfo.number : "in"
        }

        // console.log("input", key, tokenLabel)

        let startChar = -1
        while ((startChar = call.code.indexOf(key, startChar)) > -1) {
          // console.log("found it at", startChar)
          const endChar = startChar + key.length
          marks.push(
            <Mark
              key={startChar + "," + input.inside}  // TODO: no clue how to key these suckers; custom reconciliation may be needed :()
              from={startChar}
              to={endChar}
            >
              <Token className={tokenClass} nodeId={input.outside} stack={stack}>
                {tokenLabel}
              </Token>
            </Mark>
          )
          startChar = endChar
        }
      })

      return (
        <MyCodeMirror
          value={call.code}
          onValue={value => callC.select('code').set(value)}
          desiredWidth={desiredWidth}
          maxFontSize={maxFontSize}
          minFontSize={minFontSize}
          callC={callC}
          graphC={graphC}
          blockC={blockC}
        >
          {marks}
        </MyCodeMirror>
      )
    }} />
  }
}

export default CallCodeEditor



// WEBPACK FOOTER //
// ./src/view/CallCodeEditor.tsx